import React from "react";
import ReactCardFlip from "react-card-flip";

import Question from "./Question";
import CardBackFace from "./CardBackFace";
import Form from "./Form";

import useResponsive from "../../hooks/useResponsive";
import { GameContext } from "../../context/GameContext";

const Card = () => {
  const {
    userAnswer,
    setUserAnswer,
    currentQuestion,
    selected,
    setSelected,
    questionsArray,
    isFlipped,
    setIsFlipped,
    checkAlreadyAnswerd,
    setDeskQuest,
  } = React.useContext(GameContext);
  const { Default } = useResponsive();

  const addOrUpdateUserValue = (array, value) => {
    var newArray = [
      ...userAnswer.filter((obj) => obj.id !== currentQuestion),
      {
        id: currentQuestion,
        selected: value,
        correct: array.answers[value].correct,
      },
    ];
    setSelected(value);
    setUserAnswer(newArray);
  };

  const handleClick = (e, value) => {
    const current = questionsArray.find((obj) => {
      return obj.id === currentQuestion;
    });
    setIsFlipped(!isFlipped);
    addOrUpdateUserValue(current, value);
  };

  const nextQuestion = (index) => {
    checkAlreadyAnswerd(index);
  };

  const Front = () => (
    <div className="front-content">
      <Question />
      <Form
        handleSubmit={handleClick}
        selected={selected}
        isFlipped={isFlipped}
      />
      <Default>
        <button
          className="skip_button"
          onClick={() => setDeskQuest(false)}
          disabled={isFlipped ? true : false}
        >
          Tillbaka till bilden
        </button>
      </Default>
    </div>
  );

  return (
    <>
      <ReactCardFlip
        isFlipped={isFlipped}
        flipDirection="horizontal"
        flipSpeedFrontToBack={0.9}
      >
        <Front />
        {selected && <CardBackFace nextQuestion={nextQuestion} />}
      </ReactCardFlip>
    </>
  );
};

export default Card;
